import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
  /* Reset box-sizing for all elements */
  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  /* Root level variables (optional) */
  :root {
    /* Define custom CSS variables if needed */
  }
  
  /* Base styles for the body */
  body {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.backgroundPrimary};
    color: ${({ theme }) => theme.primaryText};
    font-family: ${({ theme }) => theme.typography.fontFamily.body};
    transition: background-color 0.3s ease, color 0.3s ease;
    line-height: 1.6;
  }
  
  /* Typography for headers */
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.typography.fontFamily.headings};
    font-weight: 400;
    font-optical-sizing: auto;
    font-style: normal;
    font-variation-settings:
    "SOFT" 0,
    "WONK" 0;
    line-height: 1.2;
    color: ${({ theme }) => theme.primaryText};
    margin: 0;
    font-weight:300;
  }

  /* Paragraph styling */
  p {
    font-family: ${({ theme }) => theme.typography.fontFamily.body}, serif;
    font-weight: 300;
    line-height: 1.5;
    color: ${({ theme }) => theme.primaryText};
    font-optical-sizing: auto;
    font-style: normal;
    font-variation-settings: "GRAD" 0;
    margin: 0 0 1em;
  }

  /* Inherit base font styles for common elements */
  a, span, li, input, textarea, button {
    font-family: inherit;
    color: inherit;
  }

  /* Form element focus styles */
  form *:focus {
    outline: 2.5px solid ${({ theme }) => theme.primary};
  }

  /* Textarea base styling */
  textarea {
    font-family: ${({ theme }) => theme.typography.fontFamily.body};
    font-weight: normal;
  }

  /* Fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-in {
    animation: fadeIn 1s ease-in;
  }


  .gradient-text1{
    color: ${(props) => props.theme.primary};
    background: linear-gradient(
      -182deg,
      ${(props) => props.theme.tertiary},
      ${(props) => props.theme.primary},
      ${(props) => props.theme.primary},
      ${(props) => props.theme.tertiary}
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

/* 
  .page-reveal {
  position: absolute;
  inset: 0;
  background: #fff;
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  pointer-events: none;
  animation: slideOpen 0.7s ease-out forwards;
}
@keyframes slideOpen {
  to {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
}

.page-enter {
    transform: translateX(-100%);
    opacity: 0;
  }

  .page-enter-active {
    transform: translateX(0%);
    opacity: 1;
    transition:
      transform 600ms ease,
      opacity 600ms ease;
  }

  .page-exit {
    transform: translateX(0%);
    opacity: 1;
  }

  .page-exit-active {
    transform: translateX(100%);
    opacity: 0;
    transition:
      transform 600ms ease,
      opacity 600ms ease;
  } */
`

export default GlobalStyle
